import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from "./OrganizationAppResource";
import OrganizationMoxiOfficeAppResource from "./OrganizationMoxiOfficeAppResource";
import ConnectorImportLogAppResource from "./ConnectorImportLogAppResource";

export const USER = 'user';
export const CONTACT = 'contact';
export const TRANSACTION = 'transaction';
export const LISTING = 'listing';

export const TYPE = {
    USER,
    CONTACT,
    TRANSACTION,
    LISTING,
};

class TransactionImportFilterAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'transaction-import-filter';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'transactions/imports/filters';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'enabled',
            'organizationUuid',
            'filters',
            'officeUuid',
            'importedByOrganizations',
            'type',
            'organization',
            'office',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            office: OrganizationMoxiOfficeAppResource,
            imports: ConnectorImportLogAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            office: 'office_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            enabled: {
                type: 'boolean',
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            filters: {
                type: 'object',
            },
            officeUuid: {
                type: 'string',
            },
            importedByOrganizations: {},
            type: {
                type: 'string',
                inclusion: [
                    USER,
                    CONTACT,
                    TRANSACTION,
                    LISTING,
                ]
            }
        };
    }
}

export default TransactionImportFilterAppResource;
